import useUserStore from "@/store/user.store.ts";
import { useEffect } from "react";
import { Outlet, Navigate } from "react-router";

export default function AuthGuard() {
  const { isLoggedIn, getProfile } = useUserStore();

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    getProfile();
  }, [isLoggedIn]);

  return isLoggedIn ? <Outlet /> : <Navigate to="/auth/login" replace />;
}
